export const selectOptionsLoanPurpose = [
  "Purchase",
  "Refinance - No Cash Out",
  "Refinance - Cash Out",
];
